"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("@package/utils");

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var FORM_NAME = 'payout-create';

var validate = function validate(values) {
  var errors = {};

  if (!values['shop']) {
    errors['shop'] = 'Обязательное поле';
  }

  if (values['cardholder']) {
    if (!/^[A-Za-z\s]+$/.test(values['cardholder'])) {
      errors['cardholder'] = 'Только латинские символы и пробел';
    }
  }

  if (!values['description']) {
    errors['description'] = 'Обязательное поле';
  } else if (/(\b|\D)([456]([-\s]*\d){15,18})(\b|\D)/img.test(values['description'])) {
    errors['description'] = 'Не указывайте номер карты в описании';
  }

  if (!values['method']) {
    errors['method'] = 'Обязательное поле';
  } else if (values['method'] && values['method']['name'] === 'WMR') {
    if (!values['destination']) {
      errors['destination'] = 'Обязательное поле';
    } else if (!/^[RP][0-9]{12}$/.test(values['destination'])) {
      errors['destination'] = 'Неверный тип кошелька';
    }
  } else if (values['method'] && values['method']['name'] === 'WMZ') {
    if (!values['destination']) {
      errors['destination'] = 'Обязательное поле';
    } else if (!/^[Z][0-9]{12}$/.test(values['destination'])) {
      errors['destination'] = 'Неверный тип кошелька';
    }
  } else if (values['method'] && values['method']['name'] === 'YandexMoney') {
    if (!values['destination']) {
      errors['destination'] = 'Обязательное поле';
    } else if (/\D+/.test(values['destination'])) {
      errors['destination'] = 'Неверный формат данных';
    } else if (values['destination'].length < 11 || values['destination'].length > 20) {
      errors['destination'] = 'Неверное значение. Число от 11 до 20 знаков';
    }
  } else if (values['method'] && values['method']['name'] === 'BankCard') {
    if (!values['destination']) {
      errors['destination'] = 'Обязательное поле';
    } else if (/\D+/.test(values['destination'])) {
      errors['destination'] = 'Неверный формат данных';
    } else if (values['destination'].length < 16 || values['destination'].length > 19 || values['destination'].length === 17) {
      errors['destination'] = 'Неверное значение. Должно содержать 16,18 или 19 знаков';
    }
  } else if (values['method'] && values['method']['name'] === 'Mobile') {
    if (!values['destination']) {
      errors['destination'] = 'Обязательное поле';
    } else if (!_utils.validation.phone(values['destination'])) {
      errors['destination'] = 'Неверный формат телефона';
    }
  } else if (values['method'] && values['method']['name'] === 'Qiwi') {
    if (!values['destination']) {
      errors['destination'] = 'Обязательное поле';
    } else if (!_utils.validation.phone(values['destination'])) {
      errors['destination'] = 'Неверный формат Qiwi кошелька';
    }
  }

  if (!values['description']) {
    errors['description'] = 'Обязательное поле';
  } else if (/(\b|\D)([456]([-\s]*\d){15,18})(\b|\D)/img.test(values['description'])) {
    errors['description'] = 'Не указывайте номер карты в описании';
  }

  if (values['shop']) {
    var _values$recipientFull;

    if (values['shop']['requiresRecipientFullName'] && !((_values$recipientFull = values['recipientFullName']) !== null && _values$recipientFull !== void 0 && _values$recipientFull.trim())) {
      errors['recipientFullName'] = 'Обязательное поле';
    }

    if (values['shop']['isShowCommissionCalculation']) {
      if (!values['amount-debit']) {
        errors['amount-debit'] = 'Обязательное поле';
      } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['amount-debit'])) {
        // eslint-disable-next-line
        errors['amount-debit'] = 'Неверный формат суммы';
      } else if (Number(values['amount-debit']) > Number(values['account']['available'])) {
        errors['amount-debit'] = 'Сумма списания превышает доступный баланс';
      } else if (Number(values['amount-debit']) <= 0) {
        errors['amount-debit'] = 'Сумма должна быть больше 0';
      }

      if (!values['amount-credit']) {
        errors['amount-credit'] = 'Обязательное поле';
      } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['amount-credit'])) {
        // eslint-disable-next-line
        errors['amount-credit'] = 'Неверный формат суммы';
      } else if (Number(values['amount-credit']) <= 0) {
        errors['amount-credit'] = 'Сумма должна быть больше 0';
      }
    } else {
      if (!values['amount']) {
        errors['amount'] = 'Обязательное поле';
      } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['amount'])) {
        errors['amount'] = 'Неверный формат суммы';
      } else if (values['account'] && Number(values['amount']) > Number(values['account']['available'])) {
        errors['amount'] = 'Сумма превышает доступный баланс';
      }
    }
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: FORM_NAME,
  validate: validate
})(_Component["default"]);

exports["default"] = _default;